export default __webpack_public_path__ + "static/media/Burger.02f8d49e.svg";